export default __webpack_public_path__ + "static/media/848.6be7d913.jpg";